// extracted by mini-css-extract-plugin
export default {"videoPopup":"VideoPopup_videoPopup__VSGy4","closeButton":"VideoPopup_closeButton__FBM1z","videoContainer":"VideoPopup_videoContainer__hW7jt","mobile":"VideoPopup_mobile__+tJGv"};